// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"239":"e1cd11e8a887aa94","888":"52c9ebe585663659"}[chunkId] + ".css";
};